// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__LNBNr","spin":"styles_spin__AIMQI"};